module.exports = __webpack_public_path__ + "static/media/devchanges.7904126e.svg";